import Vue from 'vue'
import moment from 'moment'
moment.locale('pt-br')

const state = {
  tickets: [],
  ticketsReaded: []
}

const mutations = {
  'SET_TICKETS_LIST' (state, tickets) {
    state.tickets = tickets
    localStorage.setItem('tickets', JSON.stringify(tickets))
  },
  'SET_TICKETS_READED_LIST' (state, ticketsReaded) {
    state.ticketsReaded = ticketsReaded
    localStorage.setItem('ticketsReaded', JSON.stringify(ticketsReaded))
  },
  'READ_TICKET' (state, {ticket, eventId}) {
    ticket.eventId = eventId
    state.ticketsReaded.push(ticket)
    localStorage.setItem('ticketsReaded', JSON.stringify(state.ticketsReaded))
  }
}

const dispatchInvalid = (dispatch) => {
  dispatch('setSnackbarColor', 'error')
  dispatch('setSnackbarMessage', 'Ingresso inválido')
  dispatch('setSnackbarOpen', true)
}

const dispatchNoAllowed = (dispatch) => {
  dispatch('setSnackbarColor', 'orange darken-3')
  dispatch('setSnackbarMessage', 'Setor Inválido')
  dispatch('setSnackbarOpen', true)
}

const dispatchAllowed = (dispatch, data) => {
  dispatch('setSnackbarColor', data.status === 'Permitido' || data.status === 'Ativo' ? 'green darken-2' : 'error')
  dispatch('setSnackbarMessage', data.status === 'Permitido' || data.status === 'Ativo' ? 'Liberado' : data.status)
  dispatch('setSnackbarOpen', true)
}

const dispatchAlreadyReaded = (dispatch, data) => {
  let readedAt = null
  let now = null
  if (typeof data.readedAt === 'string') {
    readedAt = moment(data.readedAt).format('h:mm:ss a')
    now = moment(data.readedAt).fromNow()
  } else {
    readedAt = data.readedAt.format('h:mm:ss a')
    now = data.readedAt.fromNow()
  }
  dispatch('setSnackbarColor', 'error')
  dispatch('setSnackbarMessage', `Duplicado, lido as ${readedAt} (${now})`)
  dispatch('setSnackbarOpen', true)
}

const findAllowed = (products, ticket) => {
  const allowed = products.find(product => {
    return product.id === ticket.id_product && (product.type === ticket.id_product_type || ticket.id_product_type === null)
  })

  if (allowed) return allowed.enabled || ticket.id_product_type === null; else return false
}

const offlineReading = (dispatch, commit, getters, state, ticket, eventId, readedAt) => {
  const record = state.tickets.find(element => element.code === ticket)
  if (record) {
    const allowed = findAllowed(getters.products, record)
    if (!allowed) {
      dispatchNoAllowed(dispatch)
    } else {
      if (!record.readedAt) {
        record.readedAt = readedAt || moment()
      }
      if (record.readed) {
        record.readedAt = moment(parseInt(record.readedAt) * 1000)
        dispatchAlreadyReaded(dispatch, record)
      } else {
        record.readed = true
        dispatchAllowed(dispatch, record)
      }
      commit('READ_TICKET', {ticket: record, eventId})
    }
  } else {
    dispatchInvalid(dispatch)
  }
}

const actions = {
  eraseLocalTicketData: ({commit}) => {
    commit('SET_SELECTED_EVENT', {})
    localStorage.removeItem('tickets')
  },
  loadTicketsFromLocalStore: ({commit}) => {
    const tickets = localStorage.getItem('tickets')
    if (!tickets) {
      return
    }
    commit('SET_TICKETS_LIST', JSON.parse(tickets))
  },
  eraseLocalTicketsReadedData: ({commit}) => {
    commit('SET_SELECTED_EVENT', {})
    localStorage.removeItem('ticketsReaded')
  },
  loadTicketsReadedFromLocalStore: ({commit}) => {
    const ticketsReaded = localStorage.getItem('ticketsReaded')
    if (!ticketsReaded) {
      return
    }
    commit('SET_TICKETS_READED_LIST', JSON.parse(ticketsReaded))
  },
  setEventTickets: ({commit}, eventId) => {
    Vue.http.post('tickets', { event: eventId })
      .then(response => {
        response.json().then(tickets => {
          tickets = tickets.map(ticket => {
            ticket.readed = ticket.readed === '1'
            ticket.synced = false
            if (ticket.readedAt) {
              ticket.readedAt = moment(parseInt(ticket.readedAt) * 1000)
            }
            return ticket
          })
          commit('SET_TICKETS_LIST', tickets)
        })
      })
      .catch(_ => {})
  },
  readTicket: ({commit, state, dispatch, getters}, {ticket, eventId}) => {
    const readedTicket = state.ticketsReaded.find(element => element.code === ticket)
    let readedAt = null
    readedAt = moment()
    if (readedTicket) {
      if (readedTicket.status === 'Inválido') {
        dispatchInvalid(dispatch)
        return
      }

      const allowed = findAllowed(getters.products, readedTicket)
      if (allowed) {
        if (!readedTicket.readedAt) {
          readedTicket.readedAt = readedAt || moment()
        }
        dispatchAlreadyReaded(dispatch, readedTicket)
      } else {
        dispatchNoAllowed(dispatch)
      }
    } else {
      const allowedProducts = getters.products.filter(product => product.enabled)
      const params = {
        ticket: ticket,
        event: eventId,
        allowed: allowedProducts.map(product => ({
          id_product: product.id,
          id_product_type: product.type
        }))
      }

      if (!navigator.onLine) {
        offlineReading(dispatch, commit, getters, state, ticket, eventId, readedAt)
        return
      }

      Vue.http.post('read', params)
        .then(response => {
          response.json().then(data => {
            data.synced = true
            if (data.status === 'Inválido') {
              dispatchInvalid(dispatch)
            } else if (data.status === 'Setor Inválido') {
              dispatchNoAllowed(dispatch)
            } else {
              const allowed = findAllowed(getters.products, data)
              if (allowed) {
                if (!data.readedAt) {
                  data.readedAt = readedAt || moment()
                }
                if (data.readed) {
                  data.readedAt = moment(parseInt(data.readedAt) * 1000)
                  dispatchAlreadyReaded(dispatch, data)
                } else {
                  data.readed = true
                  dispatchAllowed(dispatch, data)
                }
                commit('READ_TICKET', {ticket: data, eventId})
              } else {
                dispatchNoAllowed(dispatch)
              }
            }
          })
        })
        .catch(_ => {
          offlineReading(dispatch, commit, getters, state, ticket, eventId, readedAt)
        })
    }
  },
  syncTickets: ({commit, state}) => {
    let ticketsReaded = state.ticketsReaded.filter(ticket => !ticket.synced)
    Vue.http.post('sync', {tickets: ticketsReaded})
      .then(_ => {
        ticketsReaded = state.ticketsReaded.map(ticket => {
          ticket.synced = true
          return ticket
        })
        commit('SET_TICKETS_READED_LIST', ticketsReaded)
      })
      .catch(_ => {})
  }
}

const getters = {
  tickets (state) {
    return state.tickets
  },
  readed (state) {
    return state.ticketsReaded
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/tickets.js